import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { createProvider, Step } from '../../../../../../shared/IFE/step/step/step';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { AnalyticsService } from '../../../../../../shared/modules/analytics/services/analytics.service';
import { BooleanQuestionValues } from '../../../../models/constants';

@Component({
  selector: 'evc-quote-charging-station-access-badge',
  providers: [createProvider(ChargingStationAccessBadgeComponent)],
  templateUrl: './charging-station-access-badge.component.html',
  styleUrls: ['./charging-station-access-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChargingStationAccessBadgeComponent extends Step implements OnInit {
  readonly formName = 'evcQuote';
  readonly stepName: string = 'charging-station-access-Badge';
  readonly booleanQuestionValues = BooleanQuestionValues;

  constructor(fb: UntypedFormBuilder, analyticsService: AnalyticsService) {
    super(fb, analyticsService);
  }

  writeValue(value): void {
    if (!value) {
      super.writeValue(value);
      return;
    }

    super.writeValue({ value });
  }

  protected valueChanges(values) {
    // Make sure all our checkboxes get the event.
    this.control.get('value').patchValue(values.value, { emitEvent: false });
    super.valueChanges(values.value);
  }

  protected buildForm() {
    this.control = this.fb.group({
      value: ['', [Validators.required]],
    });
    this.subscribeToValueChanges(true);
  }
}
